import { useState } from "react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Check } from "lucide-react";

export const ContactForm = ({ vehicleTitle }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: vehicleTitle
      ? `Ik heb interesse in de ${vehicleTitle} en zou graag een bezichtiging inplannen.`
      : "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Vul uw naam en e-mailadres in.");
      return;
    }
    setSubmitting(true);
    // Mocked submit
    await new Promise((r) => setTimeout(r, 900));
    setSubmitting(false);
    setSent(true);
    toast.success("Bericht verzonden — wij nemen spoedig contact met u op.");
  };

  if (sent) {
    return (
      <div
        data-testid="contact-form-success"
        className="relative bg-ink-900 border border-champagne/30 p-10 md:p-14 text-center"
      >
        <div className="w-14 h-14 mx-auto mb-6 border border-champagne/40 flex items-center justify-center">
          <Check size={18} className="text-champagne" />
        </div>
        <h3 className="font-display text-3xl md:text-4xl text-white mb-3">
          Uw bericht is ontvangen
        </h3>
        <p className="text-sm text-zinc-400 font-body max-w-md mx-auto leading-relaxed">
          Een persoonlijk lid van Maison Vellore neemt doorgaans binnen enkele
          uren contact met u op. Wij danken u voor uw interesse.
        </p>
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      data-testid="contact-form"
      className="relative bg-ink-900 border border-white/[0.06] p-8 md:p-10 flex flex-col gap-5"
    >
      <div className="flex flex-col gap-2 mb-2">
        <span className="text-[10px] tracking-[0.3em] uppercase text-champagne font-body">
          Informeer Vrijblijvend
        </span>
        <h3 className="font-display text-2xl md:text-3xl text-white leading-tight">
          Laat uw gegevens achter
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <Field label="Naam">
          <Input
            data-testid="contact-name"
            name="name"
            type="text"
            value={form.name}
            onChange={onChange}
            className="h-11 bg-ink-950 border-white/10 focus:border-champagne focus-visible:ring-0 focus-visible:ring-offset-0 text-sm font-body text-white rounded-none"
          />
        </Field>
        <Field label="E-mailadres">
          <Input
            data-testid="contact-email"
            name="email"
            type="email"
            value={form.email}
            onChange={onChange}
            className="h-11 bg-ink-950 border-white/10 focus:border-champagne focus-visible:ring-0 focus-visible:ring-offset-0 text-sm font-body text-white rounded-none"
          />
        </Field>
      </div>

      <Field label="Telefoon (optioneel)">
        <Input
          data-testid="contact-phone"
          name="phone"
          type="tel"
          value={form.phone}
          onChange={onChange}
          className="h-11 bg-ink-950 border-white/10 focus:border-champagne focus-visible:ring-0 focus-visible:ring-offset-0 text-sm font-body text-white rounded-none"
        />
      </Field>

      <Field label="Bericht">
        <Textarea
          data-testid="contact-message"
          name="message"
          value={form.message}
          onChange={onChange}
          rows={5}
          className="bg-ink-950 border-white/10 focus:border-champagne focus-visible:ring-0 focus-visible:ring-offset-0 text-sm font-body text-white rounded-none resize-none"
        />
      </Field>

      <button
        type="submit"
        data-testid="contact-submit"
        disabled={submitting}
        className="mt-3 w-full md:w-auto px-8 py-3.5 border border-champagne text-champagne hover:bg-champagne hover:text-ink-950 transition-colors duration-500 text-[11px] tracking-[0.3em] uppercase font-body font-semibold disabled:opacity-60"
      >
        {submitting ? "Versturen..." : "Bericht Versturen"}
      </button>
    </form>
  );
};

const Field = ({ label, children }) => (
  <label className="flex flex-col gap-2">
    <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-body">
      {label}
    </span>
    {children}
  </label>
);

export default ContactForm;
